export enum ApiPaymentMovementType {
  CREDIT_CARD = 'CREDIT_CARD',
  PSE = 'PSE',
  BANK_TRANSFER = 'BANK_TRANSFER',
  MOVEMENT_TYPE_1 = '1',
  MOVEMENT_TYPE_2 = '2',
  MOVEMENT_TYPE_3 = '3',
  MOVEMENT_TYPE_4 = '4',
  MOVEMENT_TYPE_5 = '5',
  MOVEMENT_TYPE_6 = '6',
  MOVEMENT_TYPE_7 = '7',
  MOVEMENT_TYPE_8 = '8',
  MOVEMENT_TYPE_9 = '9',
  MOVEMENT_TYPE_10 = '10',
  MOVEMENT_TYPE_11 = '11',
  MOVEMENT_TYPE_12 = '12',
  MOVEMENT_TYPE_13 = '13',
  MOVEMENT_TYPE_14 = '14',
  MOVEMENT_TYPE_15 = '15',
  MOVEMENT_TYPE_16 = '16',
  MOVEMENT_TYPE_17 = '17',
  MOVEMENT_TYPE_18 = '18',
  MOVEMENT_TYPE_19 = '19',
  MOVEMENT_TYPE_20 = '20',
  MOVEMENT_TYPE_21 = '21',
  MOVEMENT_TYPE_22 = '22',
  MOVEMENT_TYPE_23 = '23',
  MOVEMENT_TYPE_26 = '26',
  MOVEMENT_TYPE_27 = '27',
  MOVEMENT_TYPE_28 = '28',
  MOVEMENT_TYPE_36 = '36',
  MOVEMENT_TYPE_37 = '37',
  MOVEMENT_TYPE_38 = '38',
  MOVEMENT_TYPE_39 = '39',
  MOVEMENT_TYPE_40 = '40',
  MOVEMENT_TYPE_41 = '41',
  MOVEMENT_TYPE_42 = '42',
  MOVEMENT_TYPE_43 = '43',
  MOVEMENT_TYPE_44 = '44',
  MOVEMENT_TYPE_45 = '45',
  MOVEMENT_TYPE_47 = '47',
  MOVEMENT_TYPE_48 = '48',
  MOVEMENT_TYPE_49 = '49',
  MOVEMENT_TYPE_50 = '50',
  MOVEMENT_TYPE_51 = '51',
  MOVEMENT_TYPE_52 = '52',
  MOVEMENT_TYPE_53 = '53',
  MOVEMENT_TYPE_54 = '54',
  MOVEMENT_TYPE_55 = '55',
  MOVEMENT_TYPE_56 = '56',
  MOVEMENT_TYPE_57 = '57',
  MOVEMENT_TYPE_58 = '58',
  MOVEMENT_TYPE_59 = '59',
  MOVEMENT_TYPE_60 = '60',
  MOVEMENT_TYPE_61 = '61',
  MOVEMENT_TYPE_62 = '62',
}
